// extracted by mini-css-extract-plugin
export default {"container":"ZP-z","title":"_P-z","link":"aQ-z"};